<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.menuManagement") }}</h4>
    </div>
    <div class="wrap_con type_bt_wrap">
      <div class="d-flex">
        <div class="brick_box w-50 m-3">
          <button class="btn btn-primary btn-sm m-3" @click="addNode">Add Node</button>
          <div class="bg-white p-3 m-3" style="overflow: auto; height: 600px">
            <vue-tree-list
              @click="onClick"
              @delete-node="onDel"
              @add-node="onAddNode"
              :model="treeData"
              default-tree-node-name="new menu"
              default-leaf-node-name="new child menu"
              v-bind:default-expanded="false"
            >
              <template v-slot:leafNameDisplay="slotProps">
                <span> {{ slotProps.model.name }} <span class="muted"></span> </span>
              </template>
              <span class="icon" slot="addTreeNode">addTreeNode</span>
              <span class="icon" slot="addLeafNodeIcon" disabled></span>
              <span class="icon" slot="editNodeIcon" disabled></span>
              <span class="icon" slot="delNodeIcon"
                ><i class="vtl-icon vtl-icon-trash m-1"></i
              ></span>
            </vue-tree-list>
          </div>
        </div>
        <div class="brick_box w-50 m-3">
          <div style="text-align: right">
            <button type="button" @click="saveMenu" class="btn btn-primary btn-sm m-1">
              {{ $t("common.save") }}
            </button>
          </div>
          <div class="p-3 m-3">
            <table class="write_tbl responsive_tbl">
              <tbody>
                <tr>
                  <th>{{ $t("management.menuNamelabel") }}</th>
                  <td>
                    <input
                      type="text"
                      v-model="menu.name"
                      name="label"
                      v-validate="'required'"
                      class="int_type01"
                    />
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("management.url") }}</th>
                  <td>
                    <input
                      type="text"
                      v-model="menu.menuUrl"
                      name="menuUrl"
                      v-validate="'required'"
                      class="int_type01"
                      :class="{ 'bg-light': isSavedMenu }"
                      :readonly="isSavedMenu"
                    />
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("management.order") }}</th>
                  <td>
                    <input
                      type="text"
                      v-model="menu.menuSequence"
                      name="menuSequence"
                      v-validate="'required'"
                      class="int_type01"
                    />
                  </td>
                </tr>
                <tr>
                  <th>{{ $t("management.useYN") }}</th>
                  <td>
                    <select class="int_type01 mgt_seltype" v-model="menu.useYn">
                      <option value="1">Y</option>
                      <option value="0">N</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <p v-if="isSavedMenu" class="small text-muted mt-2">
              {{ $t("management.urlChangeNotice") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getMgmtMenuList, saveMenu, deleteMenu } from "@/api/menu";
import { VueTreeList, Tree, TreeNode } from "vue-tree-list";
export default {
  components: {
    VueTreeList,
  },
  data() {
    return {
      treeData: new Tree([]),
      list: [],
      menu: { useYn: 1 },
      parentMenu: [],
      childMenu: [],
      thridMenu: [],
      menuShow: "",
      savedMenu: { menuId: "" },
      confirmYN: false,
      newMenu: { userYn: 1 },
    };
  },
  computed: {
    // 저장된 메뉴는 URL 을 수정할 수 없다. 서버도 menuId 유무로 insert/update 를 구분한다.
    isSavedMenu() {
      return !!this.menu.menuId;
    },
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getMgmtMenuList("2");
        this.list = data.allMenuList;
        this.parentMenu = data.parentMenu;
        this.children = data.childMenu;
        this.thridMenu = data.thridMenu;
        this.treeData = new Tree(data.parentMenu);
        for (let i in this.treeData.children) {
          this.treeData.children[i].children = [];
          for (let j in this.children) {
            if (this.treeData.children[i].id == this.children[j].pid) {
              var node2 = new TreeNode(this.children[j]);
              node2.children = [];
              for (let a in this.thridMenu) {
                if (this.children[j].id == this.thridMenu[a].pid) {
                  this.thridMenu[a].addTreeNodeDisabled = true;
                  var node1 = new TreeNode(this.thridMenu[a]);
                  node2.children.push(node1);
                }
              }

              this.treeData.children[i].children.push(node2);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    showSubMenu(menuId) {
      this.menuShow = menuId;
    },
    savePMenu(menu) {
      this.savedMenu = menu;
      this.menu = menu;
    },
    // 메뉴 저장/수정
    async saveMenu() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      this.confirmYN = confirm(this.$t("alert.save"));
      if (this.confirmYN) {
        try {
          this.newMenu.menuId = this.menu.menuId;
          this.newMenu.label = this.menu.name;
          this.newMenu.parentMenuId = this.menu.parentMenuId;
          this.newMenu.menuSequence = this.menu.menuSequence;
          this.newMenu.menuUrl = this.menu.menuUrl;
          this.newMenu.useYn = this.menu.useYn;
          this.newMenu.level = this.menu.level;
          const { data } = await saveMenu(this.newMenu);
          if (data.status) {
            // 신규 저장 시 발급된 menuId 를 반영한다. 이후 저장은 수정으로 처리되고 URL 은 잠긴다.
            this.$set(this.menu, "menuId", data.menuId);
            alert(this.$t("alert.savedSuccessfully"));
            this.fetchData();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
    async deleteMenu() {
      try {
        this.savedMenu.menuId = this.menu.menuId;
        const { data } = await deleteMenu(this.savedMenu);
        if (data.status) {
          alert(this.$t("alert.deletedSuccessfully"));
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 메뉴 삭제
    onDel(node) {
      console.log(node);
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        this.menu.menuId = node.id;
        this.deleteMenu();
        this.menu = {};
      } else {
        return;
      }
    },
    // 메뉴 추가
    onAddNode(params) {
      if (params.parent.level == 1) {
        this.menu.level = 2;
        params.level = 2;
      } else if (params.parent.level == 2) {
        this.menu.level = 3;
        params.level = 3;
        params.addTreeNodeDisabled = true;
      } else {
        return;
      }
      this.menu.label = params.name;
      this.menu.parentMenuId = params.pid;
    },
    // 클릭시
    onClick(params) {
      this.menu = params;
      if (this.menu.useYn == null) {
        this.menu.useYn = 1;
      }
      this.menu.label = params.name;
      if (params.pid != 0) {
        this.menu.parentMenuId = params.pid;
      }
      // 기존메뉴 수정일 경우
      if (params.id.length > 14) {
        this.menu.menuId = params.id;
      }
    },
    // 부모 메뉴 추가
    addNode() {
      this.menu.level = 1;
      var node = new TreeNode({ name: "new node", isLeaf: false, level: 1 });
      if (!this.treeData.children) this.treeData.children = [];
      this.treeData.addChildren(node);
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style>
.btn-secondary {
  font-size: 18px;
}
/* 
.vtl {
	margin-left: 10px;
}
.icon {
    cursor: pointer;
}

.muted {
	color: gray;
	font-size: 80%;
} */
</style>
